<template>
    <div class="page_menu_mobile_link flex-col">
        <div class="nav-container">
            <div class="group_1 flex-col">
                <div class="group_2 flex-row">
                    <div
                            class="nav-item"
                            v-for="(item, index) in menuItems"
                            :key="index"
                            @mouseenter="handleMouseEnter(index)"
                            @mouseleave="handleMouseLeave"
                            @click="handleItemClick(index,item)"
                            :class="{ active: activeIndex === index }"
                    >
                        <div class="menu-main">
                            <span class="menu-label">{{ item.label }}</span>
                            <div class="underline" :class="{ active: activeIndex === index }"></div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            defaultActiveIndex: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                constants: {},
                menuItems: [
                    {
                        label: '首页',
                        href:'home',
                        menuClass:'nav1',
                        subItems: [],
                    },
                    {
                        label: '走进康柏',
                        href:'about',
                        menuClass:'nav2',
                        subItems: [
                            { label: '关于我们', href: 'about#introduce-section2' },
                            { label: '企业荣誉', href: 'about#honor-section2' },
                            { label: '行业价值', href: 'about#value-section2' },
                            { label: '服务优势', href: 'about#server-section2' },
                        ],
                    },
                    {
                        label: '核心业务',
                        href:'Advisory',
                        menuClass:'nav3',
                        subItems: [
                            { label: '渠道风控管理', href: 'Advisory' },
                            { label: '业务合规管理', href: 'compliance' },
                            { label: '企业健康咨询', href: 'consultation' },
                        ],
                    },
                    {
                        label: '新闻中心',
                        href:'Information',
                        menuClass:'nav4',
                        subItems: [
                            { label: '康柏动态', href: 'Advisory' },
                            { label: '行业观察', href: 'compliance' },
                        ],
                    },
                    {
                        label: '联系我们',
                        href:'contact',
                        menuClass:'nav5',
                        subItems: [
                            { label: '联系我们', href: 'contact' },
                            { label: '加入我们', href: 'join' },
                        ],
                    },
                ],
                isActiveIndex: null, // 保持统一初始状态
                activeIndex: this.defaultActiveIndex,      // 默认激活第一个菜单的下划线
                defaultIndex: this.defaultActiveIndex,
                submenuVisible: false, // 新增控制二级菜单显示的状态

            };
        },
        watch: {
            // 监听props变化
            defaultActiveIndex(newVal) {
                this.defaultIndex = newVal;
                this.activeIndex = newVal;
            }
        },
        methods: {
            handleMouseEnter(index) {
                this.activeIndex = index;
                this.submenuVisible = true;
            },
            handleMouseLeave() {
                this.submenuVisible = false; // 隐藏二级菜单
                this.activeIndex = this.defaultActiveIndex;
                console.log(this.defaultActiveIndex)
            },
            handleItemClick(index,item) {
                this.goto(item.href)
            },

            handleSubmenuEnter() {
                this.keepOpen = true;
            },
            handleSubmenuLeave() {
                this.keepOpen = false;
                this.activeIndex = this.defaultIndex;
            },
            // 辅助方法，用于滚动到指定的锚点
            scrollToAnchor(anchor) {
                const element = document.getElementById(anchor);
                if (element) {
                    // 使用 scrollIntoView 平滑滚动到目标元素
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            },
            goto(url){
                url = '/' + url;
                if (url.includes('#')) {
                    this.$router.push(url).then(() => {
                        this.scrollToAnchor(url.split('#')[1]);
                    });
                } else {
                    // 如果没有包含锚点，添加默认的锚点（例如，页面顶部）
                    this.$router.push(`${url}`).then(() => {
                        window.scrollTo(0, 0);
                    });
                }
            },
            gotoSub(url){
                this.submenuVisible = false;
                url = '/' + url;
                if (url.includes('#')) {
                    this.$router.push(url).then(() => {
                        this.scrollToAnchor(url.split('#')[1]);
                    });
                } else {
                    if (this.$route.path !== url){
                        this.$router.push(`${url}`).then(() => {
                            window.scrollTo(0, 0);
                        });
                    }else{
                        window.scrollTo(0, 0);
                    }
                }
            },

        }
    };
</script>

<style scoped lang="css"  >
    .page_menu_mobile_link {
        position: relative;
        background-color: rgba(255, 255, 255, 1);
        max-width: 1200px;
        width: 100%;
        height: 76px;
        overflow: hidden;
        margin: 0 auto;
    }
    /* 新增外层容器 */
    .nav-container {
        position: relative;
        max-width: 1200px;
        margin: 0 auto;
        height: 100%;
    }

    .group_1 {
        position: relative;
        background-color: rgba(255, 255, 255, 1);
        border-radius: 6px;
        width: 100%;
        left: 0;
        top: 30px;
    }

    .group_2 {
        box-shadow: inset 0px -1px 0px 0px rgba(232, 232, 232, 1);
        background-color: rgba(255, 255, 255, 1);
        width: 100%;
        height: 76px;
        margin-top: -30px;
        justify-content: center;
        display: flex;
        align-items: center;
    }


    .nav-item {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0 1.2vw;
        cursor: pointer;
        z-index: 1000;
        margin: 0;
        flex-shrink: 0;
    }

    /* 菜单间隔线实现 */
    .nav-item:not(:last-child)::after {
        content: "";
        position: absolute;
        right: 0;
        transform: translateY(0%);
        height: 24px;
        width: 1px;
        background: #ADADAD;
        transition: background 0.3s;
    }

    /* 菜单悬停时改变间隔线颜色 */
    .nav-item:hover:not(:last-child)::after {
        background: #008683;
    }

    .menu-main {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .menu-label {
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 18px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: normal;
        padding: 8px 12px;
        transition: all 0.3s ease;
        line-height: 28px;
        display: inline-block;
    }

    /* 悬停和激活状态样式 */
    .nav-item:hover .menu-label {
        color: rgba(37, 37, 37, 1) !important;
        font-size: 20px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        transform: translateZ(0);
    }
    .nav-item.active .menu-label {
        color: rgba(37, 37, 37, 1) !important;
        font-size: 20px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        transform: translateZ(0);
    }

    .nav-item:hover .submenu {
        display: block;
    }


    .underline {
        position: absolute;
        bottom: -4px;
        width: 0;
        height: 3px;
        background: #008683;
        transition: all 0.3s;
    }

    .underline.active {
        width: 70%;
    }


    /* 动效 */
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s, transform 0.3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
        transform: translateY(-10px);
    }

    /* 移动端样式 */
    @media (max-width: 768px) {
        .group_1 {
            top: 10px;
        }

        .group_2 {
            margin-top: -10px;
            justify-content: space-around; /* 均匀分布 */
        }

        .nav-item {
            padding: 0 5px;
        }

        .menu-label {
            font-size: 12px;
            padding: 4px 6px;
        }

        .nav-item:hover .menu-label,
        .nav-item.active .menu-label {
            font-size: 13px;
        }

        .nav-item:not(:last-child)::after {
            height: 12px;
        }

        .underline {
            bottom: -1px;
            height: 1px;
        }
    }

    @media (min-width: 481px) and (max-width: 767px) {
        .nav-item {
            padding: 0 10px;
        }

        .menu-label {
            font-size: 16px;
            padding: 3px 4px;
        }

        .nav-item:hover .menu-label,
        .nav-item.active .menu-label {
            font-size: 16px;
        }

        .nav-item:not(:last-child)::after {
            height: 16px;
        }
    }
    /* 超小屏幕样式 */
    @media (max-width: 480px) {
        .nav-item {
            padding: 0 8px;
        }

        .menu-label {
            font-size: 15px;
            padding: 3px 4px;
        }

        .nav-item:hover .menu-label,
        .nav-item.active .menu-label {
            font-size: 14px;
        }

        .nav-item:not(:last-child)::after {
            height: 12px;
        }
    }
    @media (max-width: 390px) {
        .nav-item {
            padding: 0 4px;
        }

        .menu-label {
            font-size: 14px;
            padding: 4px 5px;
        }

        .nav-item:hover .menu-label,
        .nav-item.active .menu-label {
            font-size: 15px;
        }

        .nav-item:not(:last-child)::after {
            height: 10px;
        }
    }


</style>
